import { getCurrent } from '@/utils/utils';
import { Model } from 'dva';

const HomeModel: Model = {
  namespace: 'home',
  state: {
    current: 2,
    navData: [],
  },
  effects: {},
  reducers: {
    updateCurrent(state, { payload }: any) {
      return {
        ...state,
        current: payload.num,
      };
    },
    initCurrent(state, { payload }: any) {
      return {
        ...state,
        navData: payload,
        current: getCurrent(payload),
      };
    },
    updateAds(state) {
      return {
        ...state,
        showAds: false,
      };
    },
  },
};
export default HomeModel;
